import {SELFIE} from "utils/constants";

export const turnOnSelfieMode = info => ({
  type: SELFIE.SELFIE_ON,
  payload: info,
});

export const turnOffSelfieMode = info => ({
  type: SELFIE.SELFIE_OFF,
  payload: info,
});

export const takeSelfie = info => ({
  type: SELFIE.TAKE_SELFIE,
  payload: info,
});

export const switchToPicture = () => ({
  type: SELFIE.PICTURE,
});

export const switchToVideo = () => ({
  type: SELFIE.VIDEO,
});

export const stopRecord = () => ({
  type: SELFIE.STOP_RECORD,
});

export const hideAvatars = () => ({
  type: SELFIE.HIDE_AVATARS,
});

export const closeSave = () => ({
  type: SELFIE.CLOSE_SAVE,
});

export const switchHand = () => ({
  type: SELFIE.SWITCH_HAND,
});
